<template>
	<div class="ui two column stackable grid">
		<div class="ui dimmer">
			<div class="content">
				<div class="ui icon header" style="color:red;">
          <i class="cancel icon"/>
					{{ $t('globals.validation.errors.something_went_wrong') }}
				</div>
			</div>
		</div>
		<div class="sixteen wide column">
			<form class="ui form" @submit.prevent="submitForm" data-vv-scope="userFieldForm" :class="{ 'loading' : showLoader }">
				<!-- Change password and email -->
				<div class="two fields">
					<div class="field">
						<label :for="$t('pages.profile.settings.profile.form.email')">{{ $t('pages.profile.settings.profile.form.email') }}:</label>
						<div class="ui action input">
							<input type="text" :value="fetchedUser.email" disabled>
							<div class="ui button" @click="showChangeEmailModal = !showChangeEmailModal">{{ $t('globals.buttons.change') }}</div>
						</div>
					</div>
					<div class="field">
						<label :for="$t('pages.profile.settings.profile.form.password')">{{ $t('pages.profile.settings.profile.form.password') }}</label>
						<div class="ui action input">
							<input type="text" :value="$t('pages.profile.settings.profile.form.change_password')" disabled>
							<div class="ui button" @click="showChangePasswordModal = !showChangePasswordModal">{{ $t('globals.buttons.change') }}</div>
						</div>
					</div>
				</div>

        <!-- Firstname and Lastname -->
        <div class="two fields">
          <div class="field" :class="{ 'error' : errors.has('userFieldForm.firstname') }">
            <label for="firstname">{{ $t('pages.profile.settings.profile.form.first_name') }}</label>
            <div class="ui corner labeled input">
              <input
                type="text"
                name="firstname"
                v-model="firstnameLocal"
                :disabled="!!fetchedUser.firstname"
              >
            </div>
          </div>

          <div class="field" :class="{ 'error' : errors.has('userFieldForm.surname') }">
            <label for="lastname">{{ $t('pages.profile.settings.profile.form.last_name') }}</label>
            <div class="ui corner labeled input">
              <input
                type="text"
                name="surname"
                v-model="surnameLocal"
                :disabled="!!fetchedUser.surname"
              >
            </div>
          </div>
        </div>

				<!-- Custom fields -->
				<div class="two fields" v-for="(userField, index) in chunkProperty(userFields, 2)" :key="index">
          <field :field="field" :scope="'userFieldForm'" :allowEdit="field.editable" :value="fieldValues"
                 @input="changeFieldValue" :transparent="false" v-if="field" v-for="field in userField"
                 :key="field.id"/>
				</div>

				<button type="submit" class="ui blue button">
					<i class="checkmark icon"/>
					{{ $t('globals.buttons.save_changes') }}
				</button>
				<div class="ui red button" @click="cancelForm">
					<i class="cancel icon"/>
					{{ $t('globals.buttons.cancel') }}
				</div>
			</form>
		</div>

    <div class="sixteen wide column" v-if="activeMerchant.opus">
      <div class="ui divider horizontal header">
        <i class="address card icon"/>
        Social Number Settings
      </div>

      <form class="ui form" @submit.prevent="saveUserSocialNumber" data-vv-scope="userSocialNumberForm" :class="{ 'loading' : showLoaderSecond }">
        <div class="field required" :class="{ 'error' : errors.has('userSocialNumberForm.social_number') }">
          <label for="social_number">{{ $t('pages.profile.settings.profile.form.social_number') }}</label>
          <div class="ui corner labeled input">
            <input type="text" name="social_number" v-model="forms.userSocialNumber" :data-vv-as="$t('pages.profile.settings.profile.form.social_number')" v-validate="'required|numeric'">
            <div class="ui corner label">
              <i class="asterisk icon"/>
            </div>
          </div>
          <span style="color:red;" v-if="errors.has('userSocialNumberForm.social_number')">{{ errors.first('userSocialNumberForm.social_number') }}</span>
        </div>

        <button type="submit" class="ui blue button">
          <i class="checkmark icon"/>
          {{ $t('globals.buttons.save_changes') }}
        </button>
      </form>
    </div>

		<!-- change email modal -->
		<semantic-modal v-model="showChangeEmailModal" :settings="{content_classes: {content: true}, closeable: true, closeable_button: false}" class="small">
			<div class="ui header" slot="header">
				{{ $t('modals.changeemail.header') }}
			</div>
			<form @submit.prevent="validateEmailChange" data-vv-scope="change_email" class="ui form" :class="{ 'loading' : forms.changeemail.loader }">
				<div class="field" :class="{ 'error' : errors.has('change_email.email') }">
					<label for="$t('modals.changeemail.form.new_email')">{{ $t('modals.changeemail.form.new_email') }}</label>
					<div class="ui left icon input">
						<i class="user icon"/>
						<input v-model="forms.changeemail.email" type="email" :data-vv-as="$t('modals.changeemail.form.new_email')" data-vv-delay="500" name="email" v-validate="{ required: true, email: true }">
					</div>
					<span style="color: red;" v-if="errors.has('change_email.email')">{{ errors.first('change_email.email') }}</span>
				</div>

				<div class="field" :class="{ 'error' : errors.has('change_email.password') }">
					<label for="$t('modals.changeemail.form.password')">{{ $t('modals.changeemail.form.password') }}</label>
					<div class="ui left icon input">
						<i class="lock icon"/>
						<input v-model="forms.changeemail.password" :data-vv-as="$t('modals.changeemail.form.password')" type="password" name="password" v-validate="'required|min:6'">
					</div>
					<span style="color: red;" v-if="errors.has('change_email.password')">{{ errors.first('change_email.password') }}</span>
				</div>
			</form>
			<div class="actions" slot="actions">
				<div class="ui negative button">{{ $t('globals.buttons.cancel') }}</div>
				<div class="ui blue button" @click.prevent="validateEmailChange">{{ $t('globals.buttons.update') }}</div>
			</div>
		</semantic-modal>

		<semantic-modal v-model="showChangePasswordModal" :settings="{content_classes: {content: true}, closeable: true, closeable_button: false}" class="small">
			<div class="ui header" slot="header">
				{{ $t('modals.changepassword.header') }}
			</div>
			<form @submit.prevent="validatePasswordChange" class="ui form" data-vv-scope="change_password" :class="{ 'loading' : forms.changepassword.loader }">
				<div class="field" :class="{ 'error' : errors.has('change_password.password') }">
					<label :for="$t('modals.changepassword.form.old_password')">{{ $t('modals.changepassword.form.old_password') }}</label>

					<div class="ui left icon input">
						<i class="lock icon"/>
						<input type="password" v-model="forms.changepassword.old_password" data-vv-delay="500" :data-vv-as="$t('modals.changepassword.form.old_password')" name="password" v-validate="'required|min:6'">
					</div>

					<span style="color: red;" v-if="errors.has('change_password.password')">{{ errors.first('change_password.password') }}</span>
				</div>

				<div class="field" :class="{ 'error' : errors.has('change_password.new_password') }">
					<label :for="$t('modals.changepassword.form.new_password')">{{ $t('modals.changepassword.form.new_password') }}</label>

					<div class="ui left icon input">
						<i class="lock icon"/>
						<input type="password" v-model="forms.changepassword.new_password" :data-vv-as="$t('modals.changepassword.form.new_password')" name="new_password" v-validate="'required|min:6'">
					</div>

					<span style="color: red;" v-show="errors.has('change_password.new_password')">{{ errors.first('change_password.new_password') }}</span>
				</div>

				<div class="field" :class="{ 'error' : errors.has('change_password.confirm_password') }">
					<label :for="$t('modals.changepassword.form.confirm_password')">{{ $t('modals.changepassword.form.confirm_password') }}</label>

					<div class="ui left icon input">
						<i class="lock icon"/>
						<input type="password" v-model="forms.changepassword.confirm_password" :data-vv-as="$t('modals.changepassword.form.confirm_password')" name="confirm_password" v-validate="'required|min:6'">
					</div>

					<span style="color: red;" v-if="errors.has('change_password.confirm_password')">{{ errors.first('change_password.confirm_password') }}</span>
				</div>
			</form>

			<div class="actions" slot="actions">
				<div class="ui negative button">{{ $t('globals.buttons.cancel') }}</div>
				<div class="ui blue button" @click.prevent="validatePasswordChange">{{ $t('globals.buttons.update') }}</div>
			</div>
		</semantic-modal>
	</div>
</template>

<script>
	import chunk from 'lodash/chunk'
	import find from 'lodash/find'

	export default {
		name: 'ProfileSettings',

		data () {
			return {
				showChangeEmailModal: false,
				showChangePasswordModal: false,

				fieldValues: [],
				showLoader: false,
        showLoaderSecond: false,

        firstnameLocal: '',
        surnameLocal: '',

				forms: {
          userSocialNumber: this.$auth.user().social_number,

					changeemail: {
						email: '',
						password: '',
						loader: false
					},

					changepassword: {
						old_password: '',
						new_password: '',
						confirm_password: '',
						loader: false
					}
				}
			}
		},

		computed: {
			userFields () {
				return this.fetchedUser.fields
			},

			fetchedUser () {
				return this.$auth.user()
			},

			firstName () {
				return this.fetchedUser.firstname
			},

      activeMerchant () {
        return this.$store.getters.activeMerchant
      }
		},

		watch: {
			showChangeEmailModal () {
				// reset form data
				this.forms.changeemail.email = ''
				this.forms.changeemail.password = ''

				// clear errors
				this.$nextTick(function () {
					this.errors.clear('change_email')
				})
			},

			showChangePasswordModal () {
				// reset form data
				this.forms.changepassword.old_password = ''
				this.forms.changepassword.new_password = ''
				this.forms.changepassword.confirm_password = ''

				// clear errors
				this.$nextTick(function () {
					this.errors.clear('change_password')
				})
			},

      fetchedUser: {
        immediate: true,
        handler (user) {
          this.firstnameLocal = user.firstname || ''
          this.surnameLocal = user.surname || ''
        }
      }
		},

		mounted () {
			this.$nextTick(function () {
				$(this.$el).find('.ui.dimmer').dimmer()
			})
		},

		methods: {
      saveUserSocialNumber () {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll('userSocialNumberForm')
            .then(result => {
              if (result) {
                if (this.forms.userSocialNumber !== this.$auth.user().social_number) {
                  this.showLoaderSecond = true

                  this.axios.put('users/social_number', {
                    social_number: this.forms.userSocialNumber
                  })
                    .then(() => {
                      this.fetchUser()
                        .then(() => {
                          this.showLoaderSecond = false

                          this.$events.$emit('alert', {
                            header: this.$t('pages.profile.validation.success.user.saved'),
                            message: this.$t('pages.profile.validation.success.user.updated'),
                            type: 'success',
                            align: 'right'
                          })

                          resolve(true)
                        })
                    }).catch(() => {
                    this.$events.$emit('alert', {
                      header: this.$t('globals.validation.errors.something_went_wrong'),
                      message: this.$t('globals.validation.errors.try_again_later'),
                      type: 'error',
                      closebutton: true,
                      align: 'right'
                    })

                    this.showLoader = false
                    $(this.$el).find('.ui.dimmer').dimmer('show')
                    setTimeout(() => {
                      $(this.$el).find('.ui.dimmer').dimmer('hide')
                    }, 1500)
                  })
                } else {
                  resolve(true)
                }
              } else {
                reject('Validation Failed')
              }
            })
        })
      },

			submitForm () {
				return new Promise((resolve, reject) => {
					this.$validator.validateAll('userFieldForm')
					.then(result => {
						if (result) {
							if (this.fieldValues.length > 0) {
								this.showLoader = true
								var fields = []
								// handle editableFields
								$.map(this.fieldValues, function (item, index) {
									if (item.editable) {
										if (item.required) {
											if (item.value !== '') {
												fields.push({ id: item.id, value: item.value })
											}
										} else {
											if (item.value === '') {
												fields.push({ id: item.id, value: null })
											} else {
												fields.push({ id: item.id, value: item.value })
											}
										}
									}
								})

								this.axios.put('users', {
                  firstname: this.firstnameLocal,
                  surname: this.surnameLocal,
									fields: fields
								})
								.then(() => {
									this.fetchUser()
										.then(() => {
											this.showLoader = false
											this.fieldValues = []
											fields = []

											this.$events.$emit('alert', {
												header: this.$t('pages.profile.validation.success.user.saved'),
												message: this.$t('pages.profile.validation.success.user.updated'),
												type: 'success',
												align: 'right'
											})

											resolve(true)
										})
								}).catch(error => {
									const _this = this

									$.map(error.response.data.errors, function (value, index) {
										_this.errors.add(
											{
												field: index,
												msg: value[0],
												scope: 'userFieldForm'
											}
										)
									})

									this.showLoader = false
									$(this.$el).find('.ui.dimmer').dimmer('show')
									setTimeout(() => {
										$(this.$el).find('.ui.dimmer').dimmer('hide')
									}, 1500)
								})
							} else {
								resolve(true)
							}
						} else {
							reject('Validation Failed')
						}
					})
				})
			},

      cancelForm () {
        this.showLoader = true
        this.fetchUser().then(() => {
          this.errors.clear('userFieldForm')
          this.showLoader = false
        })
      },

			chunkProperty (property, chunkSize) {
				return chunk(property, chunkSize)
			},

      fetchUser () {
        return new Promise((resolve, reject) => {
          this.$auth.fetch({
            success: (user) => {
              console.log(user)
              this.firstnameLocal = user.firstname || ''
              this.surnameLocal = user.surname || ''
              resolve(user)
            },
            error: reject
          })
        })
      },

			validateEmailChange () {
				this.forms.changeemail.loader = true

				this.$validator.validateAll('change_email')
					.then(result => {
						if (result) {
							this.axios.put('users/email', {
								email: this.forms.changeemail.email,
								password: this.forms.changeemail.password
							})
							.then(result => {
								// refetch user
								this.fetchUser()

								// remove loader and hide modal
								this.forms.changeemail.loader = false // Disable Loader
								this.showChangeEmailModal = !this.showChangeEmailModal // Hide Modal

								// after dom has loaded clear errors
								this.$nextTick(function () {
									this.errors.clear('change_email')
								})

								this.$events.$emit('alert', {
									header: this.$t('pages.profile.validation.success.email.saved'),
									message: this.$t('pages.profile.validation.success.email.updated'),
									type: 'success',
									align: 'right'
								})
							}, error => {
								const _this = this // Using javascript doesn't allow direct usage of this
								this.forms.changeemail.loader = false // Disable Loader

								// map errors to the field
								$.map(error.response.data.errors, function (item, index) {
									_this.errors.add({
										field: index,
										msg: item[0],
										scope: 'change_email'
									})
								})
							})
						} else {
							// disable loader
							this.forms.changeemail.loader = false
						}
					})
			},

			validatePasswordChange () {
				this.forms.changepassword.loader = true // Start loader

				this.$validator.validateAll('change_password')
					.then(result => {
						if (result) {
							this.axios.put('users/password', {
								password: this.forms.changepassword.old_password,
								new_password: this.forms.changepassword.new_password,
								confirm_password: this.forms.changepassword.confirm_password
							})
							.then(result => {
								// fetch user
								this.fetchUser()

								// hide modal and disable load
								this.forms.changepassword.loader = false // Disable Loader
								this.showChangePasswordModal = !this.showChangePasswordModal // Hide Modal

								// after dom has loaded clear errors
								this.$nextTick(function () {
									this.errors.clear('change_password')
								})

								this.$events.$emit('alert', {
									header: this.$t('pages.profile.validation.success.password.saved'),
									message: this.$t('pages.profile.validation.success.password.updated'),
									type: 'success',
									align: 'right'
								})
							}, error => {
								const _this = this // Using javascript doesn't allow direct usage of this
								this.forms.changepassword.loader = false // Disable Loader

								// map errors to the field
								$.map(error.response.data.errors, function (item, index) {
									_this.errors.add({
										field: index,
										msg: item[0],
										scope: 'change_password'
									})
								})
							})
						} else {
							this.forms.changepassword.loader = false // disable loader
						}
					})
			},

			changeFieldValue (field) {
				if (!find(this.fieldValues, {id: field.id})) {
					this.fieldValues.push(field)
				} else {
					var arrayValue = find(this.fieldValues, {id: field.id})
					arrayValue.value = field.value
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/pages/profile/ProfileSettings.vue